import React from 'react';
import './CustomCollaboratorsMenuList.scss';

type Props = {
  children: React.ReactNode;
};

function CustomCollaboratorsMenuList({ children }: Props) {
  return (
    <div className="custom-collaborators-menu-list">
      <div>
        <div className="custom-collaborators-menu-list-content border border-color-muted">{children}</div>
      </div>
    </div>
  );
}

export default CustomCollaboratorsMenuList;
